import { PageHeader } from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import { TellUsSection } from "@/components/sections/TellUsSection";
import { VERTICALS } from "@/lib/content";

const PRINCIPLES = [
  { label: "Understand", body: "We start with the actual need." },
  { label: "Shape", body: "We determine the right approach." },
  { label: "Deliver", body: "We turn the solution into something useful." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader
        overline="About SCC"
        title="An independent consulting and solutions company."
        subtitle="Success Crest Consulting works across People & HR, Career, and AI & Digital — starting from the problem, then bringing the right capability to it."
      />

      {/* Positioning — only stated facts */}
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
          <Reveal>
            <p className="overline">What we do</p>
            <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-slate-900 md:text-4xl">
              Different Needs. Deliberate Solutions.
            </h2>
            <p className="mt-6 max-w-md text-lg leading-relaxed text-slate-600">
              SCC operates across three solution areas under a single, accountable relationship. We
              begin with what you're trying to achieve, then bring only the capability that solves it.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <ul className="grid gap-px overflow-hidden rounded-2xl border border-border bg-border">
              {VERTICALS.map((v) => (
                <li key={v.id} className="bg-white p-7">
                  <h3 className="font-heading text-lg font-bold text-slate-900">{v.name}</h3>
                  <p className="mt-2 leading-relaxed text-slate-600">{v.description}</p>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      {/* How we work */}
      <section className="border-t border-border bg-blue-50 py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal className="max-w-2xl">
            <h2 className="font-heading text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">
              How we work
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-10 border-t border-border pt-12 sm:grid-cols-3 sm:gap-0">
            {PRINCIPLES.map((p) => (
              <Reveal key={p.label} className="sm:border-l sm:border-border sm:pl-10 sm:first:border-l-0 sm:first:pl-0">
                <span className="text-sm font-semibold uppercase tracking-[0.22em] text-blue-600">{p.label}</span>
                <p className="mt-4 font-heading text-xl font-bold leading-snug tracking-tight text-slate-900 md:text-2xl">
                  {p.body}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Honest placeholder — no invented facts */}
      <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24" data-testid="about-more">
        <Reveal className="max-w-2xl">
          <p className="overline">More about SCC</p>
          <p className="mt-4 text-lg leading-relaxed text-slate-600">
            Additional details about SCC will be published here soon.
          </p>
        </Reveal>
      </section>

      <TellUsSection />
    </div>
  );
}
